const MAX_CANVAS_AREA = 268435456;
const MAX_CANVAS_WIDTH_HEIGHT = 32767;

const applyCanvasSizeLimit = (width: number, height: number) => {
  const ratio = width / height;

  if (Math.max(width, height) >= MAX_CANVAS_WIDTH_HEIGHT) {
    return {
      width: MAX_CANVAS_WIDTH_HEIGHT * Math.min(ratio, 1),
      height: MAX_CANVAS_WIDTH_HEIGHT / Math.max(ratio, 1),
    };
  }

  if (width * height < MAX_CANVAS_AREA) {
    return {
      width,
      height,
    };
  }

  const newWidth = Math.floor(Math.sqrt(MAX_CANVAS_AREA * ratio));
  const newHeight = newWidth / ratio;

  return {
    width: newWidth,
    height: newHeight,
  };
};

export default applyCanvasSizeLimit;
